import { BaseReport } from '../BaseReport';
import { useReportLoad } from '@hooks/useReportLoad';
import { count, countUnique, countUniqueTime } from '@utils/summaries';
import { basicSort, dateSort } from '@utils/sort';
import { styleTime } from '@utils/styles';
import { REPORT, REPORT_RANGE } from '@consts/reports';

export const LocationsCutLastMonthNotThisMonth = () => {
    const { data, hasData, loading } = useReportLoad({
        reportType: REPORT.ISSUES_LOCATIONS_CUT_LAST_MONTH,
        params: {},
    });

    return (
        <BaseReport
            title={'Locations that Cut Last Month, but Not This Month'}
            description={
                "This table shows you every location which cut last month, but hasn't cut this month yet, along with the date and time of the most recent cut. This could indicate the location has closed."
            }
            rangeText={'All Time'}
            loading={loading}
            hasData={hasData}
            tableOptions={{
                headers: ['Location Name', 'Reseller Name', 'Last Successful Cuts'],
                data: data.map((item) => [item.locationName, item.resellerName, item.lastSuccessfulCut]),
                summaries: [count, countUnique, countUniqueTime],
                style: [null, null, styleTime],
                sort: [basicSort, basicSort, dateSort(REPORT_RANGE.MONTHLY)],
            }}
        />
    );
};
